<template>
  <div class="mod-overlay">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar estado' : 'Nuevo estado' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- Clave -->
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Clave"
              v-model="form.Clave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Codigo del estado"
            >
          </div>

          <!-- Nombre -->
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Nombre"
              v-model="form.Nombre"
              required
              placeholder="Nombre del estado"
            >
          </div>

          <!-- PaisClave -->
          <div class="mod-field">
            <label for="PaisClave">Clave de país</label>
            <input
              type="text"
              id="PaisClave"
              v-model="form.PaisClave"
              placeholder="Clave del pais"
            >
          </div>

          <!-- Clave2 -->
          <div class="mod-field">
            <label for="Clave2">Clave secundaria</label>
            <input
              type="text"
              id="Clave2"
              v-model="form.Clave2"
              placeholder="Clave alternativa"
            >
          </div>

          <!-- ClaveErp -->
          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input
              type="text"
              id="ClaveErp"
              v-model="form.ClaveErp"
              placeholder="Mapeo con sistema ERP"
            >
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear estado' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import estadoService from './estado.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createEstado } from './estado.model';

export default {
  name: 'EstadoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createEstado(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await estadoService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
